<template>
  <div class="info">
    <div class="head-wrap content-padding">
      <img v-if="companyId != 0 && orgId != 1162" src="@/assets/huada/head-img.png" class="head-img" />
      <img v-if="companyId == 0 || orgId == 1162" src="@/assets/huada/head-img1.png" class="head-img1" />
    </div>
    <div class="content-padding">
      <div class="section-content" v-if="orgId != 1117">
        <img class="sec-title" src="@/assets/huada/block-1.png" />
        <div class="manage-info manage-info-title content">
          <div class="manage-info_content" style="padding-top: 0">
            <div class="input-wrap">
              <div class="key">业务员姓名</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonName"
                  placeholder="请输入姓名"
                />
              </div>
            </div>
            <div class="input-wrap">
              <div class="key">业务员工号</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonNo"
                  placeholder="请输入业务员工号"
                />
              </div>
            </div>
            <div class="input-wrap" style="margin-bottom: 0">
              <div class="key">业务员手机号</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonPhone"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div v-if="orgId == 1124" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1132" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsChangZhou"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1141" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsTianJin"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1161" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsChangZhou1161"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1160" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsWuXi1160"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1148" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1148"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1147" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1147"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1164" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1164"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1182" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1182"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1173" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1173"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1174" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1174"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1175" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1175"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1176" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1176"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1208" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1208"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1142" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1142"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1212" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                  v-model="form.payPersonCompany"
                  readonly
                  placeholder="请选择业务员单位"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columns1212"
                    :default-index="selectedUnitIndex"
                    @confirm="onConfirmUnit"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1216" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1216"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1233" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1233"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1169" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1169"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1183" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1183"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1403" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1403"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1412 || orgId == 1423" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="orgId == 1423 ? columns1423 : columns1412"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1422 || orgId == 1092" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">{{ orgId == 1092 ? "营销单位" : "业务员单位" }}</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    :placeholder="orgId == 1092 ? '请选择营销单位' : '请选择业务员单位'"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="orgId == 1092 ? columns1092 : columns1422"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div v-if="orgId == 1251" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">业务员单位</div>
              <div class="val">
                <van-field
                    v-model="form.payPersonCompany"
                    readonly
                    placeholder="请选择业务员单位"
                    @click="showPicker = true"
                />
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker
                      show-toolbar
                      :columns="columns1251"
                      :default-index="selectedUnitIndex"
                      @confirm="onConfirmUnit"
                      @cancel="showPicker = false"
                  />
                </van-popup>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div v-if="!configReady" class="config-status">
          <van-loading v-if="configLoading" size="20px">项目配置加载中...</van-loading>
          <template v-else>
            <p>{{ configError || "项目配置尚未加载，请重试" }}</p>
            <van-button size="small" type="info" @click="loadProductConfig()">重新加载</van-button>
          </template>
        </div>
        <div class="content" style="margin-top: -40px">
          <div
            class="manage-info manage-info-repeat"
            v-for="(item, index) in form.itemList"
            :key="index"
          >
            <!-- <div class="manage-info_header person-title" v-if="index == 0">
              <h4>客户个人信息</h4>
              <p>以人为本破除久医不治枷锁</p>
          
            </div> -->
            <div class="manage-info_content">
            <section v-if="configReady" class="section-content">
                <img class="sec-title" src="@/assets/huada/block-3.png" />
                <p v-if="!expendList.length" class="no-products">暂无可售项目</p>
                <div v-else class="project-list">
                  <ul v-for="(listItem, listIndex) in list" :key="listIndex">
                    <li
                      v-for="projectItem in listItem"
                      :key="projectItem.id"
                      :class="[
                        {
                          active: item.productList.find(
                            (item) => item.productId == projectItem.id
                          ),
                        },
                      ]"
                      @click="onHandleChoice(index, projectItem)"
                    >
                      <p class="title">{{ projectItem.name }}</p>
                      <p class="title">{{ projectItem.tag }}</p>
                      <p class="middle"></p>
                      <p v-if="!isArgId && !shouldHideAmount">￥{{ projectItem.label }}</p>
                      <div
                        class="item-success"
                        v-if="
                          item.productList.find(
                            (item) => item.productId == projectItem.id
                          )
                        "
                      >
                        <img src="@/assets/huada/select.png" />
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <section class="section-content">
                <img class="sec-title" src="@/assets/huada/block-2.png" />
                <div class="input-wrap">
                  <div class="key">姓名</div>
                  <div class="val">
                    <van-field
                      v-model="item.personName"
                      placeholder="请输入姓名"
                    />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">身份证号</div>
                  <div class="val">
                    <van-field
                      v-model="item.personIdCard"
                      placeholder="请输入身份证号"
                    />
                  </div>
                </div>
                <div class="input-wrap">
                  <div class="key">手机号</div>
                  <div class="val">
                    <van-field
                      v-model="item.personPhone"
                      placeholder="请输入手机号"
                    />
                  </div>
                </div>
              <div v-if="hasRequiredField(item, 'nation')" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">民族</div>
              <div class="val">
                <van-field
                  v-model="item.nation"
                  readonly
                  placeholder="请选择民族"
                  @click="onOpenNationPicker(index)"
                />
                <van-popup v-model="showPickerNation" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsNation"
                    :default-index="selectedNationIndex"
                    @confirm="onConfirmNation"
                    @cancel="showPickerNation = false"
                  />
                </van-popup>
              </div>
            </div>
            <div
                  class="input-wrap"
                  v-if="hasRequiredField(item, 'origin')"
                >
                  <div class="key">籍贯</div>
                  <div class="val">
                    <van-field
                      v-model="item.origin"
                      readonly
                      placeholder="请选择籍贯"
                      @click="onOpenOriginPicker(index)"
                    />
                    <van-popup v-model="showPickerOrigin" position="bottom">
                      <van-picker
                      show-toolbar
                        :columns="columnsOrigin"
                        :default-index="selectedOriginIndex"
                        @confirm="onConfirmOrigin"
                        @cancel="showPickerOrigin = false"
                      />
                    </van-popup>
                  </div>
                </div>
                <div class="input-wrap" v-if="companyId != 0 && orgId != 1162">
                  <div class="key">开始日期</div>
                  <div class="val">
                    <van-cell-group>
                      <van-cell
                        :title="form.itemList[index]['checkStartTime']"
                        @click="onHandleChoiceDate(index)"
                        :class="[{ link: !isLink }]"
                      >
                        <template #right-icon>
                          <img
                            class="right-icon"
                            src="@/assets/huada/icon-clock.png"
                          />
                        </template>
                      </van-cell>
                      <van-calendar
                        v-model="show"
                        :min-date="minDate"
                        @confirm="onConfirm"
                        color="#07A8FF"
                      />
                    </van-cell-group>
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="hasRequiredField(item, 'addressName')"
                >
                  <div class="key">邮寄地址</div>
                  <div class="val">
                    <van-field
                      v-model="item.addressName"
                      placeholder="请输入邮寄地址"
                    />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="hasRequiredField(item, 'height')"
                >
                  <div class="key">身高(cm)</div>
                  <div class="val">
                    <van-field v-model="item.height" placeholder="请填写身高" />
                  </div>
                </div>
                <div
                  class="input-wrap"
                  v-if="hasRequiredField(item, 'weight')"
                >
                  <div class="key">体重(kg)</div>
                  <div class="val">
                    <van-field v-model="item.weight" placeholder="请填写体重" />
                  </div>
                </div>
                 <div v-if="hasRequiredField(item, 'todayFlag')" class="input-wrap" style="margin-top:10px;margin-bottom: 0">
              <div class="key">是否当日应用</div>
              <div class="val">
                <van-field
                  v-model="item.todayFlag"
                  readonly
                  placeholder="请选择是否当日应用"
                  @click="onOpenTodayPicker(index)"
                />
                <van-popup v-model="showPickerToday" position="bottom">
                  <van-picker
                  show-toolbar
                    :columns="columnsToday"
                    :default-index="selectedTodayIndex"
                    @confirm="onConfirmToday"
                    @cancel="showPickerToday = false"
                  />
                </van-popup>
              </div>
            </div>
              </section>
             
              <section
                class="money section-content"
                v-if="configReady && item.productList.length"
              >
                <img class="sec-title" src="@/assets/huada/block-4.png" />
                <!-- <div class="money-title label" style="margin-top:16px;font-weight: 500;">项目费用</div> -->
                <div
                  v-for="(expendItem, expendIndex) in expendList"
                  :key="expendIndex"
                  class="money-info"
                >
                  <div
                    v-if="
                      item.productList.find(
                        (item) => item.productId == expendItem.id
                      )
                    "
                    class="money-info_content"
                  >
                    <span>{{ expendItem.name }}{{ expendItem.tag }}</span>
                    <span
                      v-if="!isArgId && !shouldHideAmount"
                      style="display: flex; align-items: center"
                      >￥{{ expendItem.label }} &nbsp;&nbsp;<van-stepper
                        @change="stepperChange(index)"
                        v-model="
                          item.productList.find(
                            (item) => item.productId == expendItem.id
                          ).productCount
                        "
                        integer
                        :max="9999"
                    /></span>
                    <span
                      v-if="!isArgId && shouldHideAmount"
                      style="display: flex; align-items: center"
                      ><van-stepper
                        @change="stepperChange(index)"
                        v-model="
                          item.productList.find(
                            (item) => item.productId == expendItem.id
                          ).productCount
                        "
                        integer
                        :max="9999"
                    /></span>
                    <span
                      v-if="isArgId"
                      style="display: flex; align-items: center"
                      ><van-stepper
                        @change="stepperChange(index)"
                        v-model="
                          item.productList.find(
                            (item) => item.productId == expendItem.id
                          ).productCount
                        "
                        integer
                        :max="9999"
                    /></span>
                  </div>
                </div>
                <div
                  v-if="!isArgId && !shouldHideAmount && orgId != 1204"
                  class="money-footer"
                >
                  <span>总计</span>
                  <span>￥{{ item.sum }}</span>
                </div>
                <div
                  v-if="
                    orgId == 1117 ||
                    orgId == 1126 ||
                    orgId == 1127 ||
                    orgId == 1204
                  "
                  class="money-footer"
                  style="display: flex; align-items: center"
                >
                  <span>{{ orgId == 1204 ? "总计" : "支付金额" }}</span>
                  <span class="van-text-cus"
                    >¥<van-field
                      v-model="item.sum"
                      @input="onManualSumInput(index, $event)"
                      :placeholder="
                        orgId == 1204
                          ? '选产品后自动合计，可修改'
                          : '请输入支付金额'
                      "
                  /></span>
                </div>
              </section>
              <div class="remove-info">
                <div
                  class="remove-user flex flex-column-center"
                  @click="onHandleRemove(index)"
                ></div>
              </div>
            </div>
          </div>
          <!-- 添加按钮 -->
          <div class="add-info">
            <div class="add-user flex flex-column-center" @click="onHandleAdd">
              <!-- <img src="@/assets/pdmInfo/plus.png" />
      <span>添加用户</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="info-footer flex flex-between flex-align-center">
      <dl v-if="!shouldHideAmount">
        <dt>总计</dt>
        <dd>￥{{ sum }}</dd>
      </dl>
      <dl v-else>
        <dt></dt>
        <dd></dd>
      </dl>
      <div class="info-footer_right">
        <div class="save btn" @click="onHandleSave"></div>
        <div class="pay-now btn" :class="{ 'is-disabled': !configReady || !expendList.length || configLoading || loading }" :aria-disabled="!configReady || !expendList.length || configLoading || loading" @click="onHandleSubmit"></div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40" vertical class="loadingDiv">支付中...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from "vant";
import {
  list,
  expendList,
  suQianList,
  expendSuQianList,
  item,
  list2,
  expendList2,
  listzhengzhou,
  expendListzhengzhou,
  listshaoyang,
  expendListshaoyang,
  keyNo1113List,
  guoShouList,
  list1423List,
  expendList1423,
  list1423Area3List,
  expendList1423Area3,
  guoShouZhuZhouList,
  expendGuoShouZhuZhouList,
  expendGuoShouList,
  nanTongList,
  expendNanTongList,
  list1422List,
  expendList1422,
  list1092List,
  expendList1092,
  yanTai1184List,
  expendYanTai1184List,
  nanTongYinBaoList,
  expendNanTongYinBaoList,
  zhuMaDianList,
  expendZhuMaDianList,
  list1405List,
  expendList1405,
  list1408Area3List,
  expendList1408Area3,
  list1409Area3List,
  expendList1409Area3,
  list1414List,
  expendList1414,
  list1414Area3List,
  expendList1414Area3,
  pingTanList,
  expendPingTanList,
  xiangTanList,
  expendXiangTanList,
  zhuZhouList,
  expendZhuZhouList,
  jiLinList,
  expendJiLinList,
  changChunList,
  expendChangChunList,
  suZhouList,
  expendSuZhouList,
  listSuZhouShenZhenList,
  expendSuZhouShenZhenList,
  suZhouWuZhongList,
  expendSuZhouWuZhongList,
  org987List,
  expendOrg987List,
  org1284List,
  expendOrg1284List,
  org1284Area3List,
  expendOrg1284Area3List,
  changZhouList,
  expendChangZhouList,
  pingDingShanList,
  expendPingDingShanList,
  taiZhouList,
  expendTaiZhouList,
  yangZhouList,
  expendYangZhouList,
  list1142List,
  expendList1142,
  zhoukouList,
  expendZhoukouList,
  list1244,
  expendList1244,
  list1245,
  expendList1245,
  list1283List,
  expendList1283,
  list1126List,
  expendList1126,
  foShanList,
  expendFoShanList,
  tianJinList,
  expendTianJinList,
  tianJinArea1List,
  expendTianJinArea1List
} from "./config";
import { getHuaDaProductConfig, onSettleInfoSubmitHuaDa,selPayOrgInfoByOrgIdNew } from "@/api";
import { normalizeHuaDaConfig, reconcileHuaDaRows, sumHuaDaProducts } from "./productConfig";
import { weixinInit } from "@/utils/wechatUtil.js";
const ORG_ID = 1113;
const ORG_ZHENGZHOU_ID = 1114;
const ORG_ZHENGZHOU1_ID = 1122;
const ORG_ZHENGZHOU2_ID = 1123;
const ORG_WANG_ID = 1117;
const ORG_SU_QIAN_ID = 1127;
const ORG_KE_YANG_ID = 1120;
const ORG_KE_ZHU_ZHOU_ID = 1126;
const ORG_KE_SU_ZHOU_ID = 1124;
const ORG_SU_ZHOU_WU_ZHONG_ID = 1402;
const ORG_987_ID = 987;
const ORG_1284_ID = 1284;
const ORG_CHANG_DE_ID = 1134;
const ORG_HUAI_HUA_ID = 1159;
const ORG_TAI_ZHOU_ID = 1161;
const ORG_YANG_ZHOU_ID = 1147;
const ORG_XU_ZHOU_ID = 1173;
const ORG_NAN_TONG_ID = 1148;
const ORG_PING_TAN_ID = 1182;
const ORG_XIANG_TAN_ID = 1189;
const ORG_YAN_TAI_ID = 1184;
const ORG_ZHU_ZHOU_ID = 1190;
const ORG_NANTONG_ID = 1270;
const ORG_JI_LIN_ID = 1203; // 吉林市
const ORG_CHANG_CHUN_ID = 1204; // 长春市
const ORG_NAN_TONG_YIN_BAO_ID = 1205; // 南通银保
const ORG_PING_DING_SHAN_ID = 1208; // 平顶山
const ORG_1142_ID = 1142;//青岛华大高客活动
const ORG_1211_ID = 1211;
const ORG_1234_ID = 1234;//周口
const ORG_1244_ID = 1244;//惠州市公司
const ORG_1245_ID = 1245;
const ORG_CHANG_ZHOU_ID = 1132;
const ORG_ZHU_MA_DIAN_ID = 1295;//驻马店
const ORG_1405_ID = 1405;
const ORG_1406_ID = 1406;
const ORG_1408_ID = 1408;
const ORG_1409_ID = 1409;
const ORG_1414_ID = 1414;
const ORG_1092_ID = 1092; // 淄博配置由原1420转移
const ORG_1422_ID = 1422;
const ORG_1423_ID = 1423; // 瑞众广东省公司
export default {
  data() {
    return {
      columns: ['张家港', '常熟', '太仓', '昆山', '吴江', '吴中', '相城', '营销二部', '营销三部','城区收展'],
      columnsChangZhou: ['武进', '直属', '拓展', '收展', '钟新', '溧阳', '金坛'],
      columnsTianJin: ['武清', '静海', '西青'],
      columns1403: ['中支', '河北', '河西', '一营', '城营', '和平', '津南', '大港', '武清', '西青', '蓟州', '塘沽', '北辰', '静海', '宁河', '宝坻', '东丽'],
      columns1412: ['南宁', '柳州', '桂林', '梧州', '北海', '崇左', '来宾', '贺州', '玉林', '百色', '河池', '钦州', '防城港', '贵港'],
      columns1423: ['广州', '深圳', '珠海', '佛山', '东莞', '中山', '江门', '惠州', '肇庆', '汕头', '潮州', '揭阳', '汕尾', '梅州', '湛江', '茂名', '阳江', '云浮', '韶关', '河源', '清远'],
      columns1422: ['泰山区', '岱岳区', '东平', '肥城', '城区个险', '新泰', '宁阳'],
      columns1092: ['博山', '城总', '临淄', '高青', '桓台', '沂源', '周村', '淄川'],
      columnsChangZhou1161: ['城区营销', '城区收展', '高港', '兴化', '靖江', '泰兴', '姜堰'],
      columnsWuXi1160: ['江阴', '宜兴', '梁溪', '锡山', '惠山', '滨湖', '城收', '南长'],
      columns1148: ['海安', '如皋', '如东', '通州', '海门', '启东', '二部', '城收'],
      columns1147: ['营销一部', '邗江', '收展一部', '收展二部', '江都', '高邮', '宝应', '仪征'],
      columns1173: ['丰县', '沛县', '铜山', '睢宁', '邳州', '新沂', '贾汪', '二部', '三部','四部','鼓楼'],
      columns1174: ['承德县', '收展部', '二收', '三收', '营销部', '隆化', '围场', '平泉', '兴隆', '营子', '宽城', '滦平', '双滦', '丰宁'],
      columns1175: ['镇江丹阳', '镇江句容', '镇江扬中', '镇江丹徒', '镇江京口'],
      columns1176: ['第一营业部','直属营销部','金湖','淮安区','洪泽','涟水','盱眙','淮阴区'],
      columns1208: ['矿区', '新新街', '平东', '卫东', '郏县', '汝州', '南环路', '宝丰', '叶县', '双河营', '湛河', '鲁山', '舞钢', '新城区'],
      columns1142: ['莱西', '平度', '即墨营服', '即墨'],
      columns1212: ['六合', '溧水', '浦口', '直属', '高淳', '理财', '江宁', '城收', '种子计划', '大厂','营销一部'],

      columns1164: ['赣榆', '东海', '灌云', '灌南', '连云', '城营', '城收'],
      columns1182: ['平潭', '江阴', '福清'],
      columns1216: ['西市', '盖州', '大石桥', '开发区', '老边', '熊岳', '站前'],
      columns1233: ['淮安区', '市区银保', '淮阴区', '涟水'],
      columns1251: ['姜堰', '泰兴', '靖江', '兴化','高新', '金融中心', '分行营业部', '高港', '城区'],
      columns1169: ['一区', '新城', '直属', '回民区', '土左','单赛罕收展'],
      columns1183: ['白云', '从化', '二部', '四部', '五部','番禺','海珠城','天河北','花都','增城','黄埔','流花','南沙','壬丰','珠江新城'],
      columnsNation: ['汉族', '壮族', '回族', '满族', '维吾尔族', '苗族', '彝族', '土家族', '藏族', '蒙古族', '侗族', '布依族', '瑶族', '白族', '朝鲜族', '哈尼族', '黎族', '哈萨克族', '傣族', '畲族', '傈僳族', '东乡族', '仡佬族', '拉祜族', '佤族', '水族', '纳西族', '羌族', '土族', '仫佬族', '锡伯族', '柯尔克孜族', '景颇族', '达斡尔族', '撒拉族', '布朗族', '毛南族', '塔吉克族', '普米族', '阿昌族', '怒族', '鄂温克族', '京族', '基诺族', '德昂族', '保安族', '俄罗斯族', '裕固族', '乌孜别克族', '门巴族', '鄂伦春族', '独龙族', '赫哲族', '高山族', '珞巴族', '塔塔尔族'],
      columnsOrigin: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省',
        '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省',
        '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省', '重庆市', '四川省',
        '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
        '新疆维吾尔自治区'
      ],
      columnsToday: ['是', '否'],
      currentItemIndex:0,
      title: "请选择日期",
      isLink: true,
      show: false,
      loading: false,
      selectedUnitIndex: 0,
      selectedNationIndex: 0,
      selectedOriginIndex: 0,
      selectedTodayIndex:0,
      // wxCode: code,
      urlString: "",
      showPicker: false,
      showPickerNation: false,
      showPickerOrigin: false,
      showPickerToday: false,
      list,
      expendList,

      form: {
        payPersonName: "", // 业务员姓名
        payPersonNameOrigin:"",//业务员原名
        payPersonNo: "", // 业务员工号
        payPersonPhone: "", // 业务员手机号
        payPersonCompany:"",//业务员单位
        itemList: [JSON.parse(JSON.stringify(item))],
      },
      selPayOrgInfo: {},
      sum: 0, // 总计
      // orgId selects historical UI rules; paymentOrgId is the active institution receiving orders.
      orgId: "",
      paymentOrgId: "",
      currentItem: null,
      currentIndex: 0,
      isManualSum: false,
      areaCode: "",
      huaDaConfigVersion: "",
      configReady: false,
      configLoading: true,
      configError: "",
    };
  },
  async created() {
    var currentDate = new Date();
    this.minDate = currentDate;
    this.orgId = localStorage.getItem("orgId") || "";
    this.paymentOrgId = this.orgId;
    this.companyId = localStorage.getItem("companyId") || "";
    this.areaCode = localStorage.getItem("areaCode") || "";
    this.urlString = window.location.href.split("#")[0];
    console.log("this.orgId", this.orgId);

    if (this.orgId == ORG_ID) {
      if(this.areaCode == "1"){
        this.list = tianJinArea1List;
        this.expendList = expendTianJinArea1List;
      }else{
        this.list = tianJinList;
        this.expendList = expendTianJinList;
      }
    }else if(this.orgId == ORG_SU_QIAN_ID){
      this.list = suQianList;
      this.expendList = expendSuQianList;
    }else if(this.orgId == ORG_YANG_ZHOU_ID){
      this.list = yangZhouList;
      this.expendList = expendYangZhouList;
    }else if(this.orgId == ORG_TAI_ZHOU_ID || this.orgId == ORG_XU_ZHOU_ID){
      this.list = taiZhouList;
      this.expendList = expendTaiZhouList;
      
    }else if(this.orgId == ORG_CHANG_DE_ID){
      this.list = changZhouList;
      this.expendList = expendChangZhouList;
    }else if(this.orgId == ORG_KE_SU_ZHOU_ID){
      // 1124：areaCode 为 2 或 3 时追加「细胞存储（定制版）」（id 18，3999）
      if(this.areaCode == 2 || this.areaCode == 3){
          this.list = listSuZhouShenZhenList;
          this.expendList = expendSuZhouShenZhenList;
      }else{
          this.list = suZhouList;
          this.expendList = expendSuZhouList;
      }
    }else if(this.orgId == ORG_SU_ZHOU_WU_ZHONG_ID){
      this.list = suZhouWuZhongList;
      this.expendList = expendSuZhouWuZhongList;
    }else if(this.orgId == ORG_987_ID){
      this.list = org987List;
      this.expendList = expendOrg987List;
    }else if(this.orgId == ORG_1284_ID){
      if(this.areaCode == "3"){
        this.list = org1284Area3List;
        this.expendList = expendOrg1284Area3List;
      }else{
        this.list = org1284List;
        this.expendList = expendOrg1284List;
      }
    }else if (this.orgId == ORG_1234_ID ) {
      this.list = zhoukouList;
      this.expendList = expendZhoukouList;
    }else if (this.orgId == ORG_1244_ID ) {
      this.list = list1244;
      this.expendList = expendList1244;
    }else if (this.orgId == ORG_1245_ID ) {
      this.list = list1245;
      this.expendList = expendList1245;
    }else if(this.orgId == ORG_KE_ZHU_ZHOU_ID){
      // 1126 株洲科养：去掉外泌体雾化
      this.list = list1126List;
      this.expendList = expendList1126;
    }else if(this.orgId == ORG_HUAI_HUA_ID){
      this.list = guoShouZhuZhouList;
      this.expendList = expendGuoShouZhuZhouList;
    }else if(this.orgId == ORG_ZHU_MA_DIAN_ID){
      // 驻马店（1295）：areaCode 为 1 或 2 时追加「IPSC时光胶囊」
      if(this.areaCode == "1" || this.areaCode == "2"){
        this.list = zhuMaDianList;
        this.expendList = expendZhuMaDianList;
      }else{
        this.list = nanTongList;
        this.expendList = expendNanTongList;
      }
    }else if(this.orgId == ORG_YAN_TAI_ID){
      this.list = yanTai1184List;
      this.expendList = expendYanTai1184List;
    }else if(this.orgId == ORG_NAN_TONG_ID || this.orgId == ORG_NANTONG_ID || this.orgId == ORG_CHANG_ZHOU_ID){
      this.list = nanTongList;
      this.expendList = expendNanTongList;
    }else if(this.orgId == ORG_PING_TAN_ID){
      this.list = pingTanList;
      this.expendList = expendPingTanList;
    }else if(this.orgId == ORG_XIANG_TAN_ID){
      this.list = xiangTanList;
      this.expendList = expendXiangTanList;
    }else if(this.orgId == ORG_ZHU_ZHOU_ID){
      this.list = zhuZhouList;
      this.expendList = expendZhuZhouList;
    }else if(this.orgId == ORG_JI_LIN_ID){
      this.list = jiLinList;
      this.expendList = expendJiLinList;
    }else if(this.orgId == ORG_CHANG_CHUN_ID){
      this.list = changChunList;
      this.expendList = expendChangChunList;
    }else if(this.orgId == ORG_NAN_TONG_YIN_BAO_ID){
      this.list = nanTongYinBaoList;
      this.expendList = expendNanTongYinBaoList;
    }else if(this.orgId == ORG_PING_DING_SHAN_ID){
      this.list = pingDingShanList;
      this.expendList = expendPingDingShanList;
    }else if(this.orgId == ORG_1142_ID){
      this.list = list1142List;
      this.expendList = expendList1142;
    }else if(this.orgId == 1283){
      // 1283 只展示基因溯源
      this.list = list1283List;
      this.expendList = expendList1283;
    }else if (this.orgId == ORG_1211_ID ) {
      this.list = listshaoyang;
      this.expendList = expendListshaoyang;
    }else if (this.orgId == ORG_1405_ID ) {
      // 1405：默认产品基础上增加「IPSC时光胶囊」
      this.list = list1405List;
      this.expendList = expendList1405;
    }else if(this.orgId == ORG_1408_ID && this.areaCode == "3"){
      // 1408 区域 3：使用专属价格配置
      this.list = list1408Area3List;
      this.expendList = expendList1408Area3;
    }else if(this.orgId == ORG_1409_ID && this.areaCode == "3"){
      // 1409 区域 3：使用专属配置，不再进入通用区域价格覆盖。
      this.list = list1409Area3List;
      this.expendList = expendList1409Area3;
    }else if(this.orgId == ORG_1414_ID){
      // 1414：基因溯源价格为 3800
      if(this.areaCode == "3"){
        this.list = list1414Area3List;
        this.expendList = expendList1414Area3;
      }else{
        this.list = list1414List;
        this.expendList = expendList1414;
      }
    }else if(this.orgId == ORG_1422_ID){
      // 泰安（1422）：基因溯源、黄金壹号、黄金壹号PLUS、心脑卫士
      this.list = list1422List;
      this.expendList = expendList1422;
    }else if(this.orgId == ORG_1092_ID){
      // 淄博（1092）：在默认产品基础上增加华大壹号PLUS、细胞存储10年期和20年期
      this.list = list1092List;
      this.expendList = expendList1092;
    }else if(this.orgId == ORG_1423_ID){
      // 瑞众广东省公司（1423）：华大壹号仅地区3为8999，其他地区保持7999。
      this.list = this.areaCode == "3" ? list1423Area3List : list1423List;
      this.expendList = this.areaCode == "3" ? expendList1423Area3 : expendList1423;
    }else if(this.companyId == 0 || this.orgId == 1162){
      this.list = guoShouList;
      this.expendList = expendGuoShouList;

      // 根据 areaCode 判断，如果等于 3，华大壹号价格为 8999（1407、1412 固定 7999，不覆盖）
      if (this.areaCode == "3" && this.orgId != 1398 && this.orgId != 1407 && this.orgId != 1412) {
        // 只影响默认情况，不影响 orgId 特殊处理的情况
        // 检查当前使用的是否是默认的 list 和 expendList
        const isDefaultList = this.list === list;
        const isGuoShouList = this.companyId == 0 || this.orgId == "1162";

        if (isDefaultList || isGuoShouList) {
          // 复制一份列表，避免修改原始配置数组
          this.list = JSON.parse(JSON.stringify(this.list));
          this.expendList = JSON.parse(JSON.stringify(this.expendList));

          this.list.forEach(listItem => {
            listItem.forEach(item => {
              if (item.id == 6 && item.name == "华大壹号") {
                item.label = 8999;
              }
            });
          });
          this.expendList.forEach(item => {
            if (item.id == 6 && item.name == "华大壹号") {
              item.label = 8999;
            }
          });
        }
      }
    }else if (this.orgId == ORG_ZHENGZHOU_ID || this.orgId == ORG_ZHENGZHOU2_ID) {
      this.list = listzhengzhou;
      this.expendList = expendListzhengzhou;
    } else if (this.orgId == ORG_ID) {
      this.list = tianJinList;
      this.expendList = expendTianJinList;
    } else if (this.orgId == ORG_1406_ID) {
      // 1406：使用默认产品列表，华大壹号固定 7999（不受 areaCode 价格覆盖影响）
      this.list = list;
      this.expendList = expendList;
    } else if (this.orgId == ORG_WANG_ID) {
      this.list = list;
      this.expendList = expendList;
      this.form.itemList.forEach((item) => {
        item.sum = "";
      });
    } else if (this.orgId == ORG_KE_YANG_ID) {
      this.list[0].map((item, index) => {
        if (item.id == 1) {
          this.list[0][index]["label"] = 3800;
        }
      });
      console.log("this.list", this.list);
    } else {
      this.list = list;
      this.expendList = expendList;
      // 根据 areaCode 判断，如果等于 3，华大壹号价格为 8999（1407、1412 固定 7999，不覆盖）
      if (this.areaCode == "3" && this.orgId != 1407 && this.orgId != 1412) {
        // 只影响默认情况，不影响 orgId 特殊处理的情况
        // 检查当前使用的是否是默认的 list 和 expendList
        const isDefaultList = this.list === list;
        const isGuoShouList = this.companyId == 0 || this.orgId == "1162";

        if (isDefaultList || isGuoShouList) {
          // 复制一份列表，避免修改原始配置数组
          this.list = JSON.parse(JSON.stringify(this.list));
          this.expendList = JSON.parse(JSON.stringify(this.expendList));

          this.list.forEach(listItem => {
            listItem.forEach(item => {
              if (item.id == 6 && item.name == "华大壹号") {
                item.label = 8999;
              }
            });
          });
          this.expendList.forEach(item => {
            if (item.id == 6 && item.name == "华大壹号") {
              item.label = 8999;
            }
          });
        }
      }
    }
    console.log("this.list", this.list);
    await this.loadProductConfig(true);
    this.wxConfigInit();
  },
  computed: {
    productCacheKey() {
      return `pdm_cache_huaDa_${this.paymentOrgId || this.orgId}_${this.areaCode || "0"}`;
    },
    isArgId() {
      return this.orgId == ORG_WANG_ID;
    },
    shouldHideAmount() {
      return (
        this.orgId == 1160 || this.orgId == 1206 || this.orgId == 1185
      );
    },
  },
  watch: {
    isArgId(newVal, oldVal) {
        if (this.configReady) this.onGetTotalSum();
    },
  },
  methods: {
    async loadProductConfig(restoreCache = false) {
      this.configReady = false;
      this.configLoading = true;
      this.configError = "";
      this.huaDaConfigVersion = "";
      try {
        const response = await getHuaDaProductConfig({
          orgId: this.paymentOrgId || this.orgId,
          areaCode: this.areaCode || "0",
          legacyGuoShou: this.companyId == 0,
        });
        if (!response || response.code != 200) {
          throw new Error((response && response.msg) || "项目配置加载失败，请重试");
        }
        const config = normalizeHuaDaConfig(response.data);
        this.paymentOrgId = String(config.orgId || this.paymentOrgId || this.orgId);
        this.orgId = String(config.legacyRuleOrgId || this.paymentOrgId);
        this.list = [config.products];
        this.expendList = config.products;
        this.huaDaConfigVersion = config.version;
        if (restoreCache) {
          try {
            const allowLegacyCache = !localStorage.getItem("pdm_cache_huaDa_legacy_imported");
            const cachedValue = localStorage.getItem(this.productCacheKey)
              || (allowLegacyCache ? localStorage.getItem("pdm_cache") : null);
            const cached = JSON.parse(cachedValue || "null");
            if (cached && Array.isArray(cached.itemList) && cached.itemList.length) {
              this.form = { ...this.form, ...cached };
              localStorage.setItem(this.productCacheKey, JSON.stringify(this.form));
              if (allowLegacyCache) {
                localStorage.setItem("pdm_cache_huaDa_legacy_imported", this.productCacheKey);
              }
            }
          } catch (error) {
            localStorage.removeItem(this.productCacheKey);
          }
        }
        this.form.itemList = reconcileHuaDaRows(this.form.itemList, config.products, this.orgId);
        if (!this.form.itemList.length) this.form.itemList = [JSON.parse(JSON.stringify(item))];
        this.configReady = true;
        this.onGetTotalSum();
        return true;
      } catch (error) {
        this.list = [];
        this.expendList = [];
        this.sum = 0;
        this.configError = error.message || "项目配置加载失败，请重试";
        Toast(this.configError);
        return false;
      } finally {
        this.configLoading = false;
      }
    },
    hasRequiredField(row, field) {
      return row.productList.some((selected) => {
        const product = this.expendList.find((candidate) => candidate.id == selected.productId);
        return product && product.requiredFields.includes(field);
      });
    },
    // 打开民族选择器时记录索引
  onOpenNationPicker(index) {
    this.currentItemIndex = index;
    this.showPickerNation = true;
  },
  // 打开籍贯选择器时记录索引
  onOpenOriginPicker(index) {
    this.currentItemIndex = index;
    this.showPickerOrigin = true;
  },
  // 打开当日应用选择器时记录索引
  onOpenTodayPicker(index) {
    this.currentItemIndex = index;
    this.showPickerToday = true;
  },
    onConfirmUnit(value, index) {
      this.form.payPersonCompany = value;
      this.selectedUnitIndex = index;
      this.showPicker = false;
    },
    onConfirmNation(value, index){
      this.showPickerNation = false;
      this.form.itemList[this.currentItemIndex].nation = value;
      this.selectedNationIndex = index;
    },
    onConfirmOrigin(value, index){
      this.showPickerOrigin = false;
      this.form.itemList[this.currentItemIndex].origin = value;
      this.selectedOriginIndex = index;
    },
    onConfirmToday(value, index){
      this.showPickerToday = false;
      this.form.itemList[this.currentItemIndex].todayFlag = value;
      this.selectedTodayIndex = index;
    },
  async getPayOrgInfo() { // 保持 async
 
  let orgIdParam = this.paymentOrgId || this.orgId;
  try {
    console.log('API调用');
    const res = await selPayOrgInfoByOrgIdNew({ // 用 await 替换 .then()
      orgId: orgIdParam,
    });
    console.log('API 返回 res:', res);
    console.log('res.code:', res?.code); // 安全访问
    if (res.code == 200) {
      this.selPayOrgInfo = res.data;
    }
  } catch (err) {
    console.error('API 调用失败:', err);
    // 可加 Toast 提示用户
    Toast('加载机构信息失败，请重试');
  }
},
    onHandleChoiceDate(index) {
      this.currentIndex = index;
      this.currentItem = this.form.itemList[index];
      this.show = true;
    },
    onPad(num) {
      return num < 10 ? "0" + num : num;
    },
    onManualSumInput(index, val) {
      // 只要输入了内容，标记为手动输入
      this.isManualSum = !!val;
      this.form.itemList[index].sum = val;
      this.$set(this.form.itemList[index], "manualSum", val !== "");
      this.onGetTotalSum();
    },
    formatDate(date) {
      return `${date.getFullYear()}-${this.onPad(
        date.getMonth() + 1
      )}-${this.onPad(date.getDate())}`;
    },
    onConfirm(date) {
      this.show = false;
      // console.log("this.formatDate(date)", this.formatDate(date));
      // this.date = this.formatDate(date);
      this.form.itemList[this.currentIndex]["checkStartTime"] =
        this.formatDate(date);
      this.isLink = false;
      this.title = this.form.itemList[this.currentIndex]["checkStartTime"];
    },
    async wxConfigInit() {
      let weixinShare = {
        publicType: 1,
        url: this.urlString,
      };
      await weixinInit(weixinShare);
    },
    //唤起微信支付
    async weixinPay(weixinPayParam) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        this.onBridgeReady(weixinPayParam);
      }
    },
    async onBridgeReady(weixinPayParam) {
      let payNoDiy = weixinPayParam.payNo;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: weixinPayParam.appId,
          timeStamp: weixinPayParam.timeStamp,
          nonceStr: weixinPayParam.nonceStr,
          package: weixinPayParam.packages,
          signType: weixinPayParam.signType,
          paySign: weixinPayParam.paySign,
        },
        function (res) {
          window.location.href =
            "https://yisheng.healthmore.net/settleInfoSuccess?payNo=" +
            payNoDiy;
          //this.$router.push(`/paysuccess?payNo=${payNoDiy}`);
        }
      );
    },
    // 添加用户
    onHandleAdd() {
      const newItem = JSON.parse(JSON.stringify(item));
      if (this.isArgId) {
        newItem.sum = ""; // Set sum to empty string for orgId == 1113
      }
      this.form.itemList.push(newItem);
    },
    //删除用户
    onHandleRemove(index) {
      if (this.form.itemList.length === 1) {
        Toast("至少保留一个用户信息");
        return;
      }
      // 删除指定索引的用户信息
      this.form.itemList.splice(index, 1);
      // 更新总金额
      this.onGetTotalSum();
    },
    // 选择
    onHandleChoice(index, item) {
      const productList = this.form.itemList[index]["productList"];
      const selectIndex = productList.findIndex(
        (item2) => item2.productId == item.id
      );
      if (selectIndex != -1) {
        productList.splice(selectIndex, 1);
      } else {
        productList.push({
          productId: item.id,
          productCount: 1,
          price: item.label,
        });
      }
      // Only calculate sum if orgId is not 1113
      if (!this.isArgId) {
        const sum = sumHuaDaProducts(productList);
        this.form.itemList[index]["sum"] = sum;
        this.$set(this.form.itemList[index], "manualSum", false);
      } else {
        // Ensure sum is empty string if not manually set
        if (!this.form.itemList[index]["sum"]) {
          this.form.itemList[index]["sum"] = "";
        }
      }
      this.onGetTotalSum();
    },
    stepperChange(listIdx) {
      // Only calculate sum if orgId is not 1113
      if (!this.isArgId) {
        this.form.itemList[listIdx]["productList"].forEach((item) => {
          const selectedItem = this.expendList.filter(
            (expendedItem) => expendedItem.id == item.productId
          );
          if (selectedItem.length) {
            item.price = selectedItem[0].label;
          }
        });
        this.form.itemList[listIdx]["sum"] = sumHuaDaProducts(this.form.itemList[listIdx]["productList"]);
        this.$set(this.form.itemList[listIdx], "manualSum", false);
      } else {
        // Ensure sum is empty string if not manually set
        if (!this.form.itemList[listIdx]["sum"]) {
          this.form.itemList[listIdx]["sum"] = "";
        }
      }
      this.onGetTotalSum();
    },
    onUpCalculation() {
      this.onGetTotalSum();
    },
    // 计算总金额
    onGetTotalSum() {
      let cents = 0;
      this.form.itemList.forEach((item) => {
        if (item.sum && item.sum !== "") {
          cents += Math.round(Number(item.sum) * 100) || 0;
        } else if (!this.isArgId) {
          item.productList.forEach((innerItem) => {
            const selectedItem = this.expendList.filter(
              (expendedItem) => expendedItem.id == innerItem.productId
            );
            if (selectedItem.length) cents += Math.round(selectedItem[0].label * 100) * innerItem.productCount;
          });
        }
      });
      this.sum = cents / 100;
    },
    // 暂存
    onHandleSave() {
      localStorage.setItem(this.productCacheKey, JSON.stringify(this.form));
      Toast("暂存成功");
    },
    // 去支付
    onHandleSubmit() {
      if (!this.configReady || !this.huaDaConfigVersion || this.configLoading || this.loading) {
        if (!this.loading) Toast("请先加载最新项目配置");
        return false;
      }
      if (!this.expendList.length) {
        Toast("暂无可售项目，暂不能支付");
        return false;
      }
      console.log("this.form", JSON.parse(JSON.stringify(this.form)));
      if (this.orgId == 1117) {
        this.form.payPersonName = "无需填写";
        this.form.payPersonNo = "00000000000000";
        this.form.payPersonPhone = "11111111111";
      }
      if (!this.form.payPersonName) {
        Toast("请填写业务员姓名");
        return false;
      }

      if (!this.form.payPersonNo) {
        Toast("请填写业务员工号");
        return false;
      }
      if (!this.form.payPersonPhone) {
        Toast("请先输入业务员手机号");
        return;
      }
      if((this.orgId == ORG_1423_ID || this.orgId == 1422 || this.orgId == 1092 || this.orgId == 1412 || this.orgId == 1403 || this.orgId == 1183 || this.orgId == 1124 || this.orgId == 1132 || this.orgId == 1141 || this.orgId == 1161 || this.orgId == 1160 || this.orgId == 1148 || this.orgId == 1147 || this.orgId == 1164 || this.orgId == 1182 || this.orgId == 1173 || this.orgId == 1174 || this.orgId == 1175 || this.orgId == 1176 || this.orgId == 1208 || this.orgId == 1212 || this.orgId == 1216) && !this.form.payPersonCompany){
        Toast(this.orgId == 1092 ? "请先选择营销单位" : "请先选择业务员单位");
        return;
      }
     
      if (this.form.payPersonPhone.length != 11) {
        Toast("请输入正确的业务员手机号");
        return;
      }
      const list = this.form.itemList;
      for (let i = 0; i < list.length; i++) {
        if (!list[i].personName) {
          Toast("请填写客户姓名");
          return false;
        }
        if (!list[i].personIdCard) {
          Toast("请填写客户客户身份证号");
          return false;
        }
        if (!list[i].personPhone) {
          Toast("请填写客户手机号");
          return false;
        }
        if (list[i].personPhone.length != 11) {
          Toast("请输入正确的客户手机号");
          return;
        }
        if (this.companyId != 0 && this.orgId != 1162 && !list[i].checkStartTime) {
          Toast("请选择检查日期");
          return;
        }
        if (!list[i].productList.length) {
          Toast("请至少选择一个项目");
          return false;
        }
        if ([1117, 1126, 1127, 1204].includes(Number(this.orgId))) {
          const sum = String(list[i].sum == null ? "" : list[i].sum).trim();
          if ((this.isArgId || sum !== "") && (!/^\d+(\.\d{1,2})?$/.test(sum)
            || Number(sum) <= 0 || Number(sum) > 99999999.99)) {
            Toast("请输入大于0且最多两位小数的支付金额");
            return false;
          }
        }
        const requiredFieldMessages = {
          nation: "请选择民族",
          origin: "请选择籍贯",
          height: "请填写身高",
          weight: "请填写体重",
          todayFlag: "请选择是否当日应用",
          addressName: "请填写邮寄地址",
        };
        for (const field of Object.keys(requiredFieldMessages)) {
          if (this.hasRequiredField(list[i], field) && !list[i][field]) {
            Toast(requiredFieldMessages[field]);
            return false;
          }
        }
      }
      // 都校验通过，暂存
      // this.onHandleSave();
      this.onHandleFinalSumit();
    },
    // 提交接口
    async onHandleFinalSumit() {
      if (!this.configReady || !this.huaDaConfigVersion || !this.expendList.length || this.configLoading || this.loading) return;
      this.loading = true;
      let code = localStorage.getItem("code") || "";
      let values = {
        wxCode: code,
        saleOrgId: this.paymentOrgId || this.orgId,
        areaCode: this.areaCode || "0",
        ...this.form,
        itemList: this.form.itemList.map((row) => {
          const values = { ...row };
          delete values.manualSum;
          return values;
        }),
        huaDaConfigVersion: this.huaDaConfigVersion,
        huaDaLegacyGuoShou: this.companyId == 0,
      };
      try {
        const res = await onSettleInfoSubmitHuaDa(values);
        console.log("res", res);
        if (res.code == 200) {
          this.weixinPay(res.data);
        } else {
          this.$toast(res.msg);
          this.loading = false;
          if (/配置|标价|价格/.test(res.msg || "")) {
            await this.loadProductConfig();
          }
        }
      } catch (err) {
        console.log("err", err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.config-status {
  margin: 25px 15px 55px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
}
.pay-now.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.no-products {
  padding: 15px 0;
  text-align: center;
  color: #969799;
  font-size: 14px;
}
.van-text-cus {
  display: flex;
  align-items: center;
  .van-field {
    padding-left: 5px;
    /deep/.van-field__control {
      color: #ff3c1c;
    }
  }
}
.section-content {
  background-color: #fff;
  border-radius: 16px;
  padding: 0 15px 15px;
  margin-bottom: 40px;
  .sec-title {
    position: relative;
    top: -20px;
    left: -15px;
    height: 45px;
  }
}
* {
  box-sizing: border-box;
}
.head-img {
  width: 100%;
  max-width: 402px;
  margin-top: -30px;
}
.head-img1 {
  width: 100%;
  max-width: 402px;
}
img {
  display: block;
  max-width: 100%;
}
.head-wrap {
  padding: 0px 0 50px;
  overflow: hidden;
  .title {
    width: 298px;
    margin-bottom: 30px;
  }
  .des {
    width: 165px;
  }
}
.content-padding {
  padding-left: 20px;
  padding-right: 20px;
}
.section {
  border-radius: 12px;
  margin-bottom: 16px;
  .sec-title {
  }
  .content {
    padding-top: 20px;
    border-radius: 12px;
  }
}
.input-wrap {
  margin-bottom: 16px;
  .key {
    color: #363636;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .val {
    /deep/ .van-cell {
      border: none;
      background-color: #eaf6fe;
      /deep/input::placeholder {
        color: #b8d7eb !important;
      }
    }
  }
}
.label {
  color: #363636 !important;
  font-size: 14px !important;
  margin-bottom: 12px !important;
}
@font-face {
  font-family: "SongtiSC";
  src: url("../../assets/pdmInfo/fonts/song.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 可选，用于字体加载期间的替代字体 */
}
@font-face {
  font-family: "songCN";
  src: url("../../assets/pdmInfo/fonts/songCN.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  /* 可选，用于字体加载期间的替代字体 */
}
img {
  margin: 0;
  display: block;
}
/deep/ .van-cell-group {
}
/deep/ .right-icon {
  width: 18px;
  height: 18px;
}
/deep/ .van-cell {
}
/deep/ .van-field__control::placeholder,
/deep/ .van-cell__title,
/deep/ .van-cell__right-icon {
}
.loadingDiv {
  position: absolute;
  left: 42%;
  top: 40%;
}
.info {
  position: relative;
  padding-bottom: 100px;
  background-color: #bbdefa;
  // background: url(../../assets/pdmInfo/test.png);
  // background-position: top left;
  // background-size: 100% auto;
  // background-repeat: repeat-y;
  // padding: 0 0 100px;
  &-banner {
    width: 100%;
  }
  .manage-info {
    // margin-bottom: 16px;
    overflow: hidden;
    margin-bottom: 20px;
    &-title {
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &-repeat {
      background-repeat: repeat-y;
      background-size: 100% 100%;
    }
    &_header {
      padding: 20px 16px 5px;
      // text-align: center;
      &.worker-title {
        h4 {
          color: #000;
          font-size: 20px;
          font-weight: 900;
          position: relative;
          padding-bottom: 10px;
          margin-bottom: 10px;
          &:after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            height: 1px;
            background: #000;
            width: 170px;
          }
        }
        p {
          font-size: 14px;
          color: #000;
        }
        img {
          width: 193px;
        }
      }
      &.person-title {
        text-align: right;
        background-repeat: no-repeat;
        background-position: left top;
        background-size: 305px 95px;
        h4 {
          font-size: 20px;
          font-weight: 900;
          color: #000;
          position: relative;
          padding-bottom: 10px;
          margin-bottom: 10px;
          &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 0;
            height: 1px;
            background: #000;
            width: 170px;
          }
        }
        p {
          font-size: 14px;
          color: #000;
        }
        img {
          width: 173px;
        }
      }
      // h4 {
      // font-family: AR XinYiGBJF UL;
      // font-size: 18px;
      // color: rgb(0, 150, 104);
      // }
      // p {
      // font-size: 13px;
      // color: rgb(0, 150, 104);
      // }
    }
    &_content {
      // background: #fff;
      // border-radius: 16px;
      padding-top: 20px;
      .link /deep/ .van-cell__title {
        color: #333;
      }
      & > p {
        color: #000;
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: 900;
      }
      /deep/ .van-cell {
        // background: rgb(246, 251, 249);
        // border-radius: 12px;
      }
      /deep/ .van-cell::after {
        border-bottom: none;
      }
      .project-list {
        // border-radius: 12px;
        // padding: 10px;
        // background: linear-gradient(
        // 181.71deg,
        // rgba(149, 244, 215, 1) -381.86%,
        // rgba(255, 255, 255, 1) 125.61%
        // );
        margin: -3px;
        ul {
          display: flex;
          margin-bottom: 6px;
          flex-wrap: wrap;
          flex-wrap: wrap;
          li {
            width: auto;
            position: relative;
            border: 1px solid #b8d7eb;
            border-radius: 8px;
            padding: 6px 9px 4px;
            margin: 3px;
            &.active {
              border: 1px solid #0374c3;
            }
            &.flex-2 {
              padding-left: 3px;
              padding-right: 3px;
            }
            &:last-child {
              margin-right: 0;
            }
            .item-success {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 16px;
              height: 16px;
              img {
                position: absolute;
                width: 100%;
                height: 100%;
              }
            }
            p {
              font-size: 11px;
              color: rgb(255, 60, 28);
              margin: 8px 0;
              text-align: center;
              font-weight: 900;
              &.title {
                font-size: 11px;
                font-weight: 500;
                color: #363636;
                margin: 2px 0;
              }
              &.middle {
                margin: 10px 8px;
                height: 1px;
                background: url("../../assets/huada/line.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                // background: linear-gradient(
                // 90deg,
                // rgba(255, 255, 255, 1) 0%,
                // rgba(212, 251, 238, 1) 50%,
                // rgba(255, 255, 255, 1) 100%
                // );
              }
            }
          }
        }
      }
      .money {
        &-title {
          color: #363636;
          font-size: 14px;
          margin-bottom: 12px;
        }
        &-info {
          &_content {
            display: flex;
            justify-content: space-between;
            margin: 14px 0;
            span {
              font-size: 13px;
              color: rgb(30, 30, 30);
              font-weight: 400;
              &:last-child {
                color: rgb(255, 60, 28);
              }
            }
          }
        }
        &-footer {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;
          border-top: 1px solid #eaf6fe;
          span {
            font-size: 16px;
            font-weight: 900;
            color: rgba(30, 30, 30);
            &:last-child {
              color: rgb(255, 60, 28);
            }
          }
        }
      }
    }
  }
  .add-info {
    padding: 0 15px 20px;
    background-color: #f7fcff;
    margin-top: -21px;
    border-radius: 0 0 16px 16px;
  }
  .remove-info {
    margin-top: -50px;
    background-color: #fff;
    padding: 15px;
  }
  .add-user {
    background: url("../../assets/huada/btn-add.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 50px;
  }
  .remove-user {
    background: url("../../assets/huada/btn-remove.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 45px;
  }
  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 20px 12px 30px;
    dl {
      dt {
        font-size: 12px;
        color: #000;
      }
      dd {
        font-size: 18px;
        color: rgb(255, 60, 28);
        font-weight: 900;
      }
    }
    &_right {
      font-size: 16px;
      font-weight: 900;
      display: flex;
      .btn {
        width: 111px;
        height: 42px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
      .save {
        background-image: url("../../assets/huada/btn-l.png");
        padding: 7px 40px;
      }
      .pay-now {
        background-image: url("../../assets/huada/btn-r.png");
        padding: 7px 20px;
      }
    }
  }
}
.info {
  background-image: url("../../assets/huada/body-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
